import { Component, h } from 'preact';

import AnalysisTableRow from './AnalysisTableRow';

import { GOVERNOR, AG } from '../colors';

import { DDHQestimatedvotes, showPrecinctsReporting } from '../endpoints';

import countiesData from 'Data/data.json';
import context from 'Data/text.json';

type Props = {
  contest: { [key: string]: any },
};

class AnalysisTable extends Component<Props> {
  constructor() {
    super();
  }

  render() {
    const { contest, candidates, counties } = this.props;

    const firstShowcaseRace = contest && contest.office == 'Governor';

    let candidatesRender, sourceMap;

    if (contest) {
      let candidates = contest.candidacies;

      // Adding the colors and new ids for the candidates in the showcase spot

      candidatesRender = firstShowcaseRace
        ? GOVERNOR.map((object) => {
            const result = candidates
              .filter((obj) => obj.name == object.name)
              .map((obj) => obj.id);
            return { ...object, id: result[0] };
          })
        : AG.map((object) => {
            const result = candidates
              .filter((obj) => obj.name == object.name)
              .map((obj) => obj.id);
            return { ...object, id: result[0] };
          });

      sourceMap = contest.source;
    }

    // This function divides each county into categories (urban, suburban, red/rural and border) and adds the total votes for the counties in these categories for each candidate. We also add up the estimated votes left to count, the total votes that all candidates received, as well as the largest number in this array.

    function groupBy(arr, criteria) {
      const newObj = arr.reduce(function (acc, currentValue) {
        if (!acc[currentValue[criteria]]) {
          acc[currentValue[criteria]] = [];
        }
        const findCounties = counties
          .filter((county) => county.county == currentValue['county'])
          .map((obj) => obj.results)[0];
        const findCounties2 = counties
          .filter((county) => county.county == currentValue['county'])
          .map((obj) => obj[DDHQestimatedvotes])[0];
        let arrayCounties = {
          ...currentValue,
          ...findCounties,
          estimated_votes: findCounties2,
        };
        acc[currentValue[criteria]].push(arrayCounties);
        return acc;
      }, {});

      const summedEntries = [];

      Object.entries(newObj).forEach(function (val, idx) {
        const result = val[1].reduce((r, e, i, a) => {
          const candidateIds = Object.keys(e);
          candidateIds.forEach((k) => (r[k] = (r[k] || 0) + parseInt(e[k])));

          if (!a[i + 1])
            Object.keys(e)
              .filter((k) => typeof e[k] == 'string')
              .forEach((k) => (r[k] /= val[1].length));
          r['category'] = e.category;
          delete r['county'];
          delete r['county_CAPS'];

          return r;
        });
        summedEntries.push(result);
      });
      return summedEntries;
    }

    // This function adds a key (border, red, suburban, urban) to each array

    function createArray(arr, criteria) {
      const newObj = arr.reduce(function (acc, currentValue) {
        if (!acc[currentValue[criteria]]) {
          acc[currentValue[criteria]] = [];
        }
        acc[currentValue[criteria]].push(currentValue);
        return acc;
      }, []);

      Object.entries(newObj).forEach(function (item, idx) {
        function sum(obj) {
          var sum = 0;
          var arrayToGetMost = [];
          for (var el in obj) {
            if (el !== 'category' && el !== 'estimated_votes') {
              sum += parseFloat(obj[el]);
              arrayToGetMost.push(obj[el]);
            }
          }
          return [sum, arrayToGetMost];
        }
        var totals = sum(item[1][0]);
        item[1][0].total_votes = totals[0];
        item[1][0].votes_still_to_count =
          item[1][0].estimated_votes - totals[0];
        totals[1].push(item[1][0].estimated_votes - totals[0]);
        item[1][0].largest_number = Math.max(...totals[1]);
        delete item[1][0].category;
      });
      return newObj;
    }

    const countiesByCategory = groupBy(countiesData.counties, 'category');

    const arrayByCategories = createArray(countiesByCategory, 'category');

    // Turn the arrayByCategories into entries for easy looping

    const objectCategories = Object.entries(arrayByCategories);

    // Find the largest number in all of the arrays for all categories. Also, add the sum of votes left to count. This is so when the count hits zero for all categories, we don't show the note at the bottom of the graphic talking about Decision Desk's turnout estimates mode.

    let arrayToGetLargest = [];

    var sumofVotesLeftToCount = 0;

    objectCategories.forEach((item) => {
      arrayToGetLargest.push(item[1][0].largest_number);
      sumofVotesLeftToCount += item[1][0].votes_still_to_count;
    });

    return (
      <span>
        <h3 class='category__title t-sans'>{context.categories_headline}</h3>
        <div class='category-grids t-sans'>
          {objectCategories.map((categories) => (
            <AnalysisTableRow
              contest={contest}
              category={categories[0]}
              maxNum={Math.max(...arrayToGetLargest)}
              categoryNumbers={categories}
              candidates={candidates}
              candidatesRender={candidatesRender}
            />
          ))}
        </div>
        {sumofVotesLeftToCount > 0 || showPrecinctsReporting == false && (
          <ul class='graphic-footer'>
            <li data-note>Note: {context.categories_notes}</li>
          </ul>
        )}
      </span>
    );
  }
}

export default AnalysisTable;
